import {PlantUpmIdAdapter} from '@features/rcfa-list'
import {useUpmPlantsContext} from '@hconnect/upm'
import {Outlet} from 'react-router'

import {useUrlParam} from '../hooks/useUrlParam'

export const PlantRouteLayout: React.FC = () => {
  const plantCode = useUrlParam('plantId')
  const upmPlants = useUpmPlantsContext({isInitialLoad: false})

  const plantUpmId = plantCode ? upmPlants[plantCode].upmId : undefined

  if (!plantUpmId) {
    throw new Error('Plant UPM ID not found for plant code: ' + plantCode)
  }

  return (
    <PlantUpmIdAdapter plantUpmId={plantUpmId}>
      <Outlet />
    </PlantUpmIdAdapter>
  )
}
